"use strict";

/**
* Реквизит карточки типа «Ссылка на запись справочника».
*
* @class WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {object} data Данные для инициализации реквизита
* @since 5.5.0.1000
*/
(function (global) {

  /**
  * @inner
  * @since 5.5.0.1000
  */
  var onControlInitComplete = function (jControl, callback) {
    if (jControl.data('ReferenceSelectInstance')) {
      callback();
    } else {
      jControl.bind('Init', function () {
        callback();
      });
    }
  };

  var BaseObjectSelectRequisite = global.WA.CMP.wrappers.form.requisites.BaseRequisite.extend({
    className: "BaseObjectSelectRequisite",

    /**
    * Получить контролы реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_bindEvents
    * @private
    * @return {array} список jquery объектов
    * @since 5.5.0.1000
    */
    _getControls: function () {
      var me = this;
      var res = [];

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];

      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];
        var jControl = $('input#' + id);
        res.push(jControl);
      }

      return res;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_showSpinner
    * @since 5.5.0.1000
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite
    */
    _showSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var jContainer = jControl.parents('.reference_requisite');
        jContainer.find('.Req_Icon').hide();
        jContainer.append('<div class="circle-spinner refselect-input__spinner"></div>');
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_hideSpinner
    * @since 5.5.0.1000
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite
    */
    _hideSpinner: function () {
      var me = this;
      for (var i = 0; i < me.controls.length; i++) {
        var jControl = me.controls[i];
        var jContainer = jControl.parents('.reference_requisite');
        jContainer.find('.Req_Icon').show(); //FIXME: Не всегда все иконки должны быть отображены
        jContainer.find('.circle-spinner').remove();
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает отображаемое значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#getDisplayValue
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {
      if (this._data && this._data.isRendered === false) return this._data.displayValue;
      if (this.controls.length === 0) return;
      var jCustomControl = opt_jControl || this.controls[0].prev("span");
      var jInput = this.controls[0];
      if (jInput.hasClass('rs_custom') && jInput.data('selected') == 'false') {
        return jInput.val();
      } else {
        var values = [];
        jCustomControl.parents('.rs_SelItems').children("span").each(function () {
          values.push($(this).attr("data-text"));
        });
        return values.join(';');
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Устанавливает значения отображаемых и неотображаемых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#setValue
    * @param value {string} Устанавливаемое значение
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {boolean} Признак необходимости вызова события change
	  * @param [opt_leadRequisiteValues] {boolean} Признак ведущего реквизита
    * @return {WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite} Текущий объект реквизита – BaseObjectSelectRequisite.
    * @since 5.5.0.1000
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues) {
      var me = this;
      opt_needTriggerResult = (opt_needTriggerResult !== false);

      if (me.controls.length === 0) return me._setInvisibleValues(value, opt_displayValue, opt_needTriggerResult);

      $.each(me.controls, function () {
        WA.CMP.wrappers.form.requisites.BaseObjectSelectRequisite.setControlValue(this, value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues);
      });

      this.touch();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить значение в поле по его имени.
    *
    * @private
    * @function WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_getControlValue
    * @since 5.5.0.1000
    */
    _getControlValue: function (controlName) {
      var value;

      var jHidden = $('#hSelID_' + controlName);

      var jInput = this.controls[0];
      if (jInput.hasClass('rs_custom')) {
        if (jInput.data('selected') == 'false') {
          value = '$' + jInput.val();
        } else {
          value = jHidden.val();
        }
      } else {
        value = jHidden.val();
      }

      return (value && value !== '$') ? value : '';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Возвращает признак недоступности реквизита справочника для изменения.
     *
     * @function WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#isDisabled
	 * @comment почему функция, а не метод?
     * @return {Boolean} True – реквизит справочника доступен только для чтения, иначе False.
     * @since 5.5.0.1000
     */
    isDisabled: function () {
      var isDisabled = false;
      $(this.controls).each(function (index) {
        if ($(this).attr('readonly') === "readonly") isDisabled = true;
      });
      return isDisabled;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
    * Отключение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_disableControl
    * @private
    * @return {WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite}
    * @since 5.5.0.1000
    */
    _disableControl: function (jControl) {
      onControlInitComplete(jControl, function () { jControl.SetDisabled() });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
    * Включение контрола реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_enableControl
    * @private
    * @return {WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite}
    * @since 5.5.0.1000
    */
    _enableControl: function (jControl) {
      onControlInitComplete(jControl, function () { jControl.SetEnabled(); });
      return this;
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация событий.
    *
    * @private
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_bindEvents
    * @since 5.5.0.1000
    * @return  WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite
    */
    _bindEvents: function () {
      var me = this;

      if (me.controls.length === 0) {
        var controlInit = $.Deferred();
        me._allControlsInit.push(controlInit);
        controlInit.resolve();
        return me;
      }

      $.each(me.controls, function () {
        me._bindControlEvents(this);
      });

      return me;
    },

    /**
     * Вызвать событие изменения для реквизитов типа Справочники и Документ.
     *
     * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#_fireObjectSelectRequisiteChange     
     * @param {object} jControl Контрол.
     * @param {object} event Событие, в рамках которого вызывает функция.    
     * @param {object} setData Устанавливаемое значение.
     * @private
     */
    _fireObjectSelectRequisiteChange(jControl, event, setData) {      
      this.touch();
      this.fire('change', jControl, event, setData);
    },


    _bindControlEvents: function (jControl) {
      var me = this;

      var controlInit = $.Deferred();
      me._allControlsInit.push(controlInit);

      onControlInitComplete(jControl, function () {

        var rs = jControl.data('ReferenceSelectInstance');
        var reqFullName = me.fullName;
        if (!!rs) {
          if (rs.multiselect) {
            jControl.resultMulti(function (ev, changedData, data) {
              var res = [];
              if (data) {
                if (!$.isArray(data)) {
                  data = [data];
                };
                for (var i = 0; i < data.length; i++) {
                  res.push({ name: reqFullName, value: data[i].groupcode + ':' + data[i].id, displayValue: data[i].name });
                }
              }
              me._fireObjectSelectRequisiteChange(jControl, ev, res);
              me._parent.fire('change', jControl, ev, res);
              return this;
            });
          } else {

            jControl.result(function (ev, data) {
              if (data == null) {
                data = [null, null, null, '{}'];
              }
              me._fireObjectSelectRequisiteChange(jControl, ev, { name: reqFullName, value: data[0], displayValue: data[2] });
              me.fire('changeWithLeaderValues', jControl, ev, { name: reqFullName, value: data[0], displayValue: data[2], leaderRequisiteValues: $.parseJSON(data[3]) }, true);
              // Обращаемся к форме через _parent, т.к. WA.CR.form может вернуть форму, к которой текущий реквизит не принадлежит
              // (например, для диалогов, открытых на странице записи справочника).
              me._parent.fire('change', jControl, ev, { name: reqFullName, value: data[0], displayValue: data[2] });
            });
          }
          if (!rs.allowlike) {
            jControl
              .on('change', function (ev) {
                var value = jControl.val();
                const requisiteData = {
                  name: reqFullName,
                  value: `$${value}`,
                  displayValue: value,
                };
                me._fireObjectSelectRequisiteChange(jControl, ev, requisiteData);
                me._parent.fire('change', jControl, ev, requisiteData);
              })
              .on('changeOnSelectValue', function (ev, data) {
                if (data == null) {
                  data = [null, null, null, '{}'];
                }
                var value = data[0];
                var displayValue = data[2];
                const requisiteData = {
                  name: reqFullName,
                  value: value,
                  displayValue: displayValue,
                };
                me._fireObjectSelectRequisiteChange(jControl, ev, requisiteData);
                me._parent.fire('change', jControl, ev, requisiteData);
              });
          }
        }

        // Бывает случаи когда он изменяется без срабатывания событий выше, но изменения должны уходить на сервер. Например, при очистке ведущего, очищается ведомый.
        jControl.on('change', function (ev) {
          me.touch();
        });

        controlInit.resolve();
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Возвращает признак возможности множественного выбора.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseObjectSelectRequisite#isMultiselect
    * @return {boolean} True - если реквизит поддерживает множественный выбор, иначе - False.
	* @since 5.4.0.1013
    */
    isMultiselect: function () {
      return false;
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * @static
  */
  BaseObjectSelectRequisite.setControlValue = (jControl, value, opt_displayValue, opt_needTriggerResult, opt_leadRequisiteValues) => {
    const id = jControl.attr('id');
    const jHidd = $("#hSelID_" + id);
    if (jHidd.length > 0) {
      jControl.attr("title", opt_displayValue);

      if (!$('html').hasClass('mobile')) {
        if (value) {
          const referenceSelectData = jControl.data('ReferenceSelectInstance');
          const leadRequisiteValues = opt_leadRequisiteValues ? JSON.stringify(opt_leadRequisiteValues) : '{}';
          if (!!referenceSelectData && (referenceSelectData.multiselect)) {
          // если множественный выбор, то значения записываются в виде "СПР:11111;СПР2:23233"
            const values = ('' + value).split(";");
            const displayValues = ('' + opt_displayValue).split(";");
            onControlInitComplete(jControl, () => {
              jControl.Clear();
              for (let i = 0; i < values.length; i++) {
                jControl.SetValue(['' + values[i], displayValues[i], displayValues[i], leadRequisiteValues], opt_needTriggerResult);
              };
            });
          } else {
            onControlInitComplete(jControl, () => {
              jControl.SetValue(['' + value, opt_displayValue, opt_displayValue, leadRequisiteValues], opt_needTriggerResult);
            });
          }
        } else {
          onControlInitComplete(jControl, () => {
            jControl.SetValue(['', '', '', '{}'], opt_needTriggerResult);
          });
        }
      } else {
        jControl.val(opt_displayValue);
      }
      jControl.SetSelected(true);
    }
  };

  global.WA.CMP.wrappers.form.requisites.BaseObjectSelectRequisite = BaseObjectSelectRequisite;
})(window);